import {createStorageDriver} from './helpers';

import EventEmitter from 'wolfy87-eventemitter';
import Events from './../Events';

const DEFAULT_TOKEN_KEY = 'abaAccessToken';
const DEFAULT_TOKEN_EXPIRATION_TIME_KEY = 'abaAccessTokenExpiresIn';
const DEFAULT_REFRESH_TOKEN_KEY = 'abaRefreshTokenKey';
const DEFAULT_USER_INFO_KEY = 'abaUserInfoKey';
const DEFAULT_USER_INFO_EXPIRES_IN_KEY = 'abaUserInfoExpiresIn';
const DEFAULT_USER_INFO_TTL = 1000 * 60 * 60 * 12;

class Storage extends EventEmitter {
    constructor(
        tokenKey = DEFAULT_TOKEN_KEY,
        expiresInKey = DEFAULT_TOKEN_EXPIRATION_TIME_KEY,
        refreshTokenKey = DEFAULT_REFRESH_TOKEN_KEY,
        userInfoKey = DEFAULT_USER_INFO_KEY,
        userInfoExpiresInKey = DEFAULT_USER_INFO_EXPIRES_IN_KEY,
        ttl = DEFAULT_USER_INFO_TTL
    ) {
        super();
        this.$storage = createStorageDriver();
        this.$tokenKey = tokenKey;
        this.$expiresInKey = expiresInKey;
        this.$refreshTokenKey = refreshTokenKey;
        this.$userInfoKey = userInfoKey;
        this.$userInfoExpiresInKey = userInfoExpiresInKey;
        this.$ttl = ttl;
    }

    setToken(accessToken, expiresIn, refreshToken = null) {
        this.removeToken();
        this.$storage.set(this.$tokenKey, accessToken);
        this.$storage.set(this.$expiresInKey, expiresIn);
        if (refreshToken) {
            this.$storage.set(this.$refreshTokenKey, refreshToken);
        }
    }

    removeToken(onlyAccessToken = false) {
        this.$storage.remove(this.$tokenKey);
        this.$storage.remove(this.$expiresInKey);
        this.$storage.remove(this.$userInfoKey);
        if (!onlyAccessToken) {
            this.$storage.remove(this.$refreshTokenKey);
        }
    }

    isTokenExpired() {
        let now = (new Date()).getTime();
        let expiresIn = parseInt(this.getExpiresIn());
        if (!Number.isInteger(expiresIn)) {
            return true;
        }
        return now >= expiresIn;
    }
    getToken() {
        return this.$storage.get(this.$tokenKey);
    }

    getExpiresIn() {
        return this.$storage.get(this.$expiresInKey);
    }

    getRefreshToken() {
        return this.$storage.get(this.$refreshTokenKey);
    }

    getUserInfo() {
      if(this.ifUserInfoExpired()) {
        this.emit(Events.USER_INFO_EXPIRED);
      }

      let info = this.$storage.get(this.$userInfoKey) || null;
      if (info) {
            return JSON.parse(info);
        } else {
            return null;
        }
    }

    setUserInfo(info) {
        this.setUserInfoExpiresIn();
        return this.$storage.set(this.$userInfoKey, JSON.stringify(info));
    }

    ifUserInfoExpired() {
      return this.getUserInfoExpiresIn() !== null && this.getUserInfoExpiresIn() < (new Date()).getTime()
    }

    setUserInfoExpiresIn() {
      let expiresIn = (new Date()).getTime() + this.$ttl;
      return this.$storage.set(this.$userInfoExpiresInKey, expiresIn);
    }

    getUserInfoExpiresIn() {
      return this.$storage.get(this.$userInfoExpiresInKey);
    }

  clear() {
    return this.$storage.clear();
  }
}

export default Storage;



// WEBPACK FOOTER //
// ./src/common/auth/storage/Storage.js